import GetMyActiveTaskRequest from "../../service/request/GetMyActiveTaskRequest";
import CompleteTaskRequest from "../../service/request/CompleteTaskRequest";

import SimpleWarningDialog from "../../components/SimpleWarningDialog";
import ProvisionsNotMetDialog from "../../components/ProvisionsNotMetDialog";
import TaskApi from "../../service/TaskService";
import OtpApi from "../../service/OtpService";
import PreferenceApi from "../../service/PreferenceService";
import LeadPartyApi from "../../service/LeadPartyService";
import VideoCallCompleteProvisionApi from "../../service/VideoCallCompleteProvisionService";
import { mapGetters, mapActions } from "vuex";
import { BusinessProcessStatus } from "../../constants";

export default {
  name: "jitsi-meeting",
  components: {
    SimpleWarningDialog,
    ProvisionsNotMetDialog
  },
  props: {
    roomName: {
      type: String,
      required: true
    },
    tckn: {
      type: String,
      validator: value => {
        return value && value.length === 11;
      }
    },
    leadPartyId: {
      type: Number,
      required: true
    },
    screenshotCount: {
      type: Number
    },
    imagesUploaded: {
      type: Boolean
    },
    faceRecStatus: {
      type: Number,
      required: true
    },
    faceRecValue: {
      type: Number,
      required: true
    },
    addressApproved: {
      type: Boolean,
      default: false
    },
    imagesUploading: {
      type: Boolean,
      default: false
    },
    primaryContactType: {
      type: String,
      required: true
    },
    selected: {
      type: Array,
      default: () => []
    },
    allListItems:{
      type: Array,
      default: () => []
    }
  },
  beforeMount: function() {
    if(this.isEmpty(this.$route.query.processId)) {
      this.processId = this.$store.getters["processId"];
    } else {
      this.processId = this.$route.query.processId;
    }
  },
  data: () => ({
    hasUploadAction: false,
    checkCustomerLeft: false,
    showCustomActions: false,
    showMeetingCompletingDialog: false,
    showMeetingCancellingDialog: false,
    isLoading: true,
    stateValues: {
      componentToRedirect: "",
      checkCustomerLeftIntervalId: 0,
      phoneApproved: false,
      recording: false,
      waitingForRecordingToStop: false
    },
    showSmsSentDialog: false,
    sendSmsSnackbar: false,
    smsSend: false,
    contractManagementLink: "",
    cancelLoading: false,
    completeLoading: false,
    showOnlyParticipantError: false,
    showCustomerLeftWarning: false,
    hangingUp: false,
    rawProvisions: [],
    allProvisions: [],
    provisionsRetrieved: false,
    contractApproved: false,
    showProvisionsNotMetDialog: false,
    showDeletingAllScreenshotsDialog: false,
    customerDisconnected: false,
    isProcessAvailableForFaceRecognition: false,
    isVideoOtpEnabled: false,
    taskId: "",
    domain: "",
    birthDate: "",
    isContractEnabled: false,
    isContractListEnabled: false,
    processContractApproved: null,
    contractInfoList: "",
    isCheckListCompleted: false,
    processId: "",
  }),
  watch: {
    checkCustomerLeft: function(state) {
      if (!this.hangingUp && state) {
        this.stateValues.checkCustomerLeftIntervalId = setInterval(() => {
          if (this.processId !== null) {
            this.retrieveMyActiveTask().then(response => {
              if (
                response &&
                response.activeResourceTask &&
                response.activeResourceTask.businessProcessStatusDTO
              ) {
                const businessProcessStatus =
                  response.activeResourceTask.businessProcessStatusDTO.name;
                if (
                  businessProcessStatus ===
                    BusinessProcessStatus.VIDEO_REJECTED_BY_CUSTOMER ||
                  businessProcessStatus === BusinessProcessStatus.VIDEO_STARTED
                ) {
                  this.checkCustomerLeft = false;
                  this.showCustomerLeftWarning = true;

                  this.customerDisconnected =
                    businessProcessStatus ===
                    BusinessProcessStatus.VIDEO_STARTED;
                }
              }
            });
          } else {
            clearInterval(this.stateValues.checkCustomerLeftIntervalId);
          }
        }, 2500);
      } else {
        clearInterval(this.stateValues.checkCustomerLeftIntervalId);
      }
    },
    selectedControl: function() {
      this.isAllRequiredChecked();
    }
  },
  computed: {
    ...mapGetters(["processCode", "screenshotLoading"]),
    phoneApproved: function() {
      console.log("phoneApproved", this.stateValues.phoneApproved);
      return this.stateValues.phoneApproved;
    },
    provisions: function() {
      return this.rawProvisions.map(rawProvision => {
        const screenshotCount = this.$parent.capturedScreenshots.filter(
          capturedScreenshot =>
            capturedScreenshot.checked &&
            capturedScreenshot.value === rawProvision.code
        ).length;
        return {
          key: "doctype_" + rawProvision.code,
          min: rawProvision.min,
          screenshotCount: screenshotCount,
          met:
            screenshotCount >= rawProvision.min &&
            screenshotCount <= rawProvision.max
        };
      });
    },

    provisionsMet: function() {
      for (const rawProvision of this.rawProvisions) {
        const screenshotCount = this.$parent.capturedScreenshots.filter(
          capturedScreenshot =>
            capturedScreenshot.checked &&
            capturedScreenshot.value === rawProvision.code
        ).length;
        if (
          screenshotCount < rawProvision.min ||
          screenshotCount > rawProvision.max
        ) {
          return false;
        }
      }
      return true;
    },
    contractControl : function(){
      console.log("processContractApproved" + this.processContractApproved);
      console.log("isContractEnabledbutContractControl" + this.isContractEnabled); //false

      if(this.processContractApproved == null ){
        return false;
      } else if (this.processContractApproved == true && this.isContractEnabled == false){
        return true;
      } else {
        return false;
      }
    },
    contractAlert : function(){
      if (this.contractControl || this.contractApproved)
        return true;
      else 
        return false;
    },
    anyScreenshotCaptured: function() {
      return this.$parent.capturedScreenshots.length !== 0;
    },
    everyScreenshotChecked: function() {
      return (
        this.anyScreenshotCaptured &&
        this.$parent.capturedScreenshots.every(
          capturedScreenshot => capturedScreenshot.checked === true
        )
      );
    },
    selectedControl: function(){
      return this.$store.getters["selected"];
    }
  },
  beforeDestroy() {
    this.removeJitsiWidget();
  },
  destroyed() {
    clearInterval(this.stateValues.checkCustomerLeftIntervalId);
  },
  async mounted() {
    this.retrieveContractManagementLink();
    this.retrieveProvisions();

    const taskId = await this.retrieveTaskId();
    this.taskId = taskId;

    const protocol = await this.getJitsiProtocolFromPreferences();

    const domain = await this.getJitsiDomainFromTask();

    if (!domain) {
      throw new Error("jitsiDomain not found in processVariables.");
    }

    this.domain = domain;

    const externalApiUrl = `${protocol}://${domain}/external_api.js`;
    await this.addJitsiWidget(domain, externalApiUrl);
  },
  methods: {
    ...mapActions(["setProcessCode", "screenShotLoading"]),
    retrieveContractManagementLink() {
      PreferenceApi.getContractManagementLink(
        this,
        response => {
          if (response && response.result) {
            this.contractManagementLink = response.result.value;
          }
        },
        error => {
          console.log(error);
        }
      );
    },
    isAllRequiredChecked(){
      const selected =  this.$store.getters["selected"]
      const requiredList = this.allListItems.filter(item => item.min > 0);
      for (const required of requiredList){
        if(!selected.includes(required.code)){
          this.isCheckListCompleted = false;
          console.log("isCheckListCompleted  ");
          console.log(this.isCheckListCompleted);
          return false;
        }
      }
      this.isCheckListCompleted = true;
      console.log("isCheckListCompleted  ");
      console.log(this.isCheckListCompleted);
      return true;
    },
    retrieveProvisions() {
      VideoCallCompleteProvisionApi.getProvisionsByProcessId(
        this,
        this.processId,
        response => {
          if (response && response.result) {
            //this.rawProvisions = response.result;
            this.allProvisions = response.result;
            this.rawProvisions = this.allProvisions.filter(x => x.type == "COMPLETE_LIST");
            this.provisionsRetrieved = true;
          }
        },
        error => {
          console.log(error);
        }
      );
    },
    loadScript(src, cb) {
      const scriptEl = document.createElement("script");
      scriptEl.src = src;
      scriptEl.async = 1;
      document.querySelector("head").appendChild(scriptEl);
      scriptEl.addEventListener("load", cb);
    },
    selectAllScreenshots() {
      this.$emit("selectAllScreenshots");
    },
    async addJitsiWidget(domain, externalApiUrl) {
      this.loadScript(externalApiUrl, async () => {
        if (!window.JitsiMeetExternalAPI) {
          throw new Error("Jitsi Meet API not loaded");
        }
        var options = {
          roomName: this.roomName,
          parentNode: this.$refs.jitsiContainer,
          width: "100%",
          height: "100%",
          configOverwrite: {
            enableWelcomePage: false,
            remoteVideoMenu: {
              disableKick: true
            },
            disableRemoteMute: true
          },
          interfaceConfigOverwrite: {
            DEFAULT_REMOTE_DISPLAY_NAME: this.$t("default_remote_display_name")
            //TOOLBAR_BUTTONS: enabledJitsiToolbarButtons
          },
          onload: this.onJitsiApiLoaded
        };
        console.log("Jitsi Options", options);
        // this.jitsiApi.executeCommand('overwriteConfig', {
        //   toolbarButtons: ['recording']
        // });
        this.jitsiApi = new window.JitsiMeetExternalAPI(domain, options);
      });
    },
    onJitsiApiLoaded() {
      this.isLoading = false;
      this.jitsiApi.on("videoConferenceJoined", this.onVideoConferenceJoined);
      this.jitsiApi.on("videoConferenceLeft", this.onVideoConferenceLeft);
      this.jitsiApi.on("participantLeft", this.onParticipantLeft);
      this.jitsiApi.on("participantJoined", this.onParticipantJoined);
      this.jitsiApi.on("readyToClose", this.onReadyToClose);
      this.jitsiApi.on("recordingStatusChanged", this.onRecordingStatusChanged);
    },
    async onVideoConferenceJoined() {
      const enabledJitsiToolbarButtons = await this.addMeetingIdToProcess(
        this.taskId,
        this.domain
      );
      this.jitsiApi.executeCommand("overwriteConfig", {
        toolbarButtons: enabledJitsiToolbarButtons
      });
      this.showCustomActions = true;
    },
    onVideoConferenceLeft() {
      this.showCustomActions = false;
    },
    onParticipantLeft() {
      if (this.jitsiApi.getNumberOfParticipants() < 2) {
        this.checkCustomerLeft = true;
      }
    },
    onParticipantJoined() {
      this.checkCustomerLeft = false;
    },
    onReadyToClose() {
      setTimeout(() => {
        this.$router.push({
          name: this.stateValues.componentToRedirect,
          params: {
            tckn: this.tckn
          }
        });
      }, 2000);
    },
    onRecordingStatusChanged(status) {
      console.log("RecordingStatusChanged: " + status);
      this.stateValues.recording = status.on;

      if (this.stateValues.waitingForRecordingToStop && !status.on) {
        this.concludeMeeting();
      }
    },
    addEventListener(event, fn) {
      this.jitsiApi.on(event, fn);
    },
    onClickToggleCustomerCard() {
      this.$emit("onClickToggleCustomerCard");
    },
    onClickDeleteAllScreenshots() {
      this.showDeletingAllScreenshotsDialog = true;
    },
    onClickCaptureScreenshot() {
      if (this.jitsiApi.getNumberOfParticipants() < 2) {
        this.showOnlyParticipantError = true;
        return;
      }

      this.jitsiApi.captureLargeVideoScreenshot().then(dataURL => {
        this.$emit("onScreenshotCaptured", dataURL.dataURL);
      });
    },
    onClickUploadScreenshots() {
      if (this.provisionsMet) {
        this.$emit("onClickUploadScreenshots");
      } else {
        this.showProvisionsNotMetDialog = true;
      }
    },
    onClickCancelMeeting() {
      this.showMeetingCancellingDialog = true;
    },
    onClickCompleteMeeting() {
      this.showMeetingCompletingDialog = true;
    },
    hideOnlyParticipantError() {
      this.showOnlyParticipantError = false;
    },
    async onCloseCustomerLeftWarning() {
      this.showCustomerLeftWarning = false;

      if (this.customerDisconnected) {
        const taskId = await this.retrieveTaskId();
        await this.completeVideoCallFailedTask(taskId);
      }
      this.retrieveMyActiveTask();
      this.stateValues.componentToRedirect = "AuthAndVideoCall";
      this.$store.dispatch("clearProcessId");

      this.concludeMeeting();
    },
    hideProvisionsNotMetDialog() {
      this.showProvisionsNotMetDialog = false;
    },
    async cancelMeeting() {
      this.showMeetingCancellingDialog = false;
      this.cancelLoading = true;

      const taskId = await this.retrieveTaskId();
      await this.completeTask(taskId, "rejected");
      await this.retrieveMyActiveTask();
      this.stateValues.componentToRedirect = "AuthAndVideoCall";
      this.$store.dispatch("clearProcessId");

      this.cancelLoading = false;
      this.concludeMeeting();
    },
    async completeMeeting() {
      this.showMeetingCompletingDialog = false;
      this.completeLoading = true;

      const taskId = await this.retrieveTaskId();
      // const processID = this.$store.getters["processId"];
      await this.completeTask(taskId, "succeed");

      this.stateValues.componentToRedirect = "AuthAndVideoCall";
      this.$store.dispatch("clearProcessId");

      if (this.stateValues.recording) {
        this.stateValues.waitingForRecordingToStop = true;
        this.jitsiApi.executeCommand("stopRecording", "file");
      } else {
        this.completeLoading = false;
        this.concludeMeeting();
        // this.toShowApprovalPage(processID, this.tckn);
      }
    },
    concludeMeeting() {
      this.hangingUp = true;
      this.jitsiApi.executeCommand("hangup");
    },
    toShowApprovalPage(processId, tckn) {
      const getMyActiveTaskRequest = new GetMyActiveTaskRequest();
      getMyActiveTaskRequest.processId = processId;

      TaskApi.getMyActiveTask(
        this,
        getMyActiveTaskRequest,
        response => {
          if (response.activeResourceTask.resourceKey === "ShowApproval") {
            this.$router.push({
              name: response.activeResourceTask.resourceKey,
              params: {
                processId: processId,
                tckn: tckn
              }
            });
          } else {
            const completeTaskRequest = new CompleteTaskRequest();
            completeTaskRequest.taskId = response.activeResourceTask.taskId;
            TaskApi.completeTask(this, completeTaskRequest, response => {
              this.$router.push({
                name: response.activeResourceTask.resourceKey,
                params: {
                  processId: processId,
                  tckn: tckn
                }
              });
            });
          }
        },
        error => {
          console.log(error);
        }
      );
    },
    deleteAllScreenshots() {
      this.$emit("onAllScreenshotsDeleted");
      this.showDeletingAllScreenshotsDialog = false;
    },
    retrieveMyActiveTask() {
      return new Promise(resolve => {
        const getMyActiveTaskRequest = new GetMyActiveTaskRequest();
        getMyActiveTaskRequest.processId = this.processId;

        TaskApi.getMyActiveTask(
          this,
          getMyActiveTaskRequest,
          response => {
            resolve(response);
          },
          error => {
            console.log(error);
            resolve();
          }
        );
      });
    },
    retrieveTaskId() {
      return new Promise(resolve => {
        this.retrieveMyActiveTask().then(response => {
          if (response) {
            if (
              response &&
              response.activeResourceTask &&
              response.activeResourceTask.taskId
            ) {
              resolve(response.activeResourceTask.taskId);
            } else {
              console.log("response.activeResourceTask.taskId not found.");
              resolve();
            }
          }
        });
      });
    },
    completeTask(taskId, status) {
      return new Promise(resolve => {
        const completeTaskRequest = new CompleteTaskRequest();
        completeTaskRequest.taskId = taskId;
        completeTaskRequest.variables = [
          {
            code: "videoCallStatus",
            value: status
          },
          {
            code: "domainCode",
            value: this.$store.getters["user"].domainCode
          },
          {
            code: "faceRecognitionRatio",
            value: this.faceRecValue
          },
          {
            code: "selectedCheckListItems",
            value: this.$store.getters["selected"].toString()
          }
        ];

        TaskApi.completeTask(
          this,
          completeTaskRequest,
          () => {
            resolve();
          },
          error => {
            console.error(error);
            resolve();
          }
        );
      });
    },
    completeVideoCallFailedTask(taskId) {
      return new Promise(resolve => {
        const completeTaskRequest = new CompleteTaskRequest();
        completeTaskRequest.taskId = taskId;
        completeTaskRequest.variables = [
          {
            code: "videoCallStatus",
            value: "failed"
          }
        ];

        TaskApi.completeTask(
          this,
          completeTaskRequest,
          () => {
            resolve();
          },
          error => {
            console.error(error);
            resolve();
          }
        );
      });
    },
    onClickSendSmsActivationCode() {
      if (!this.stateValues.phoneApproved) {
        OtpApi.send(
          this,
          this.processId,
          this.leadPartyId,
          () => {
            this.sendSmsSnackbar = true;
            const phoneVerifyInterval = setInterval(() => {
              this.checkPhoneVerify(phoneVerifyInterval);
            }, 2000);
          },
          error => {
            console.log(error, "sendOTPError");
          }
        );
      }
    },
    onClickToContractManagement() {
      console.log("BirthDate:****", this.birthDate);
      if (this.birthDate !== null && this.birthDate !== "") {
        window.open(
          `${this.contractManagementLink}${this.tckn}&processId=${this.processId}&birthDate=${this.birthDate}`,
          "_blank"
        );
      } else {
        window.open(
          `${this.contractManagementLink}${this.tckn}&processId=${this.processId}`,
          "_blank"
        );
      }
      this.contractApproved = true;
    },

    downloadData(dataAsBase64) {
      var link = document.createElement("a");
      link.download = "screenshot.png";
      link.href = dataAsBase64;
      link.click();
    },
    removeJitsiWidget() {
      if (this.jitsiApi) this.jitsiApi.dispose();
    },
    async addMeetingIdToProcess(taskId, domain) {
      return new Promise(resolve => {
        const completeTaskRequest = new CompleteTaskRequest();
        completeTaskRequest.taskId = taskId;
        completeTaskRequest.variables = [
          {
            code: "jitsiDomain",
            value: domain
          },
          {
            code: "roomName",
            value: this.roomName
          },
          {
            code: "waitingChoice",
            value: "videocallpage"
          }
        ];

        TaskApi.completeTask(
          this,
          completeTaskRequest,
          response => {
            this.$emit("showCustomerCardOpen");
            const getMyActiveTaskRequest = new GetMyActiveTaskRequest();
            getMyActiveTaskRequest.processId =
              response.activeResourceTask.processId;

            TaskApi.getMyActiveTask(
              this,
              getMyActiveTaskRequest,
              response => {
                this.isProcessAvailableForFaceRecognition =
                  response.activeResourceTask.processVariables.find(
                    x => x.code == "isProcessAvailableForFaceRecognition"
                  ).value === "true"
                    ? true
                    : false;
                this.$emit(
                  "setProcessAvailableForFaceRecognition",
                  this.isProcessAvailableForFaceRecognition
                );

                this.isVideoOtpEnabled =
                  response.activeResourceTask.processVariables.find(
                    x => x.code == "isVideoOtpEnabled"
                  ).value === "true"
                    ? true
                    : false;
                this.$emit("setVideoOtpEnabled", this.isVideoOtpEnabled);

                this.stateValues.phoneApproved =
                  response.activeResourceTask.processVariables.find(
                    x => x.code == "phoneVerified"
                  ).value === "true"
                    ? true
                    : false;

                this.isContractEnabled =
                  response.activeResourceTask.processVariables.find(
                    x => x.code == "isContractEnabled"
                  ).value === "true"
                    ? true
                    : false;

                this.isContractListEnabled =
                  response.activeResourceTask.processVariables.find(
                    x => x.code == "isContractListEnabled"
                  ).value === "true"
                    ? true
                    : false;
                this.$emit(
                  "setIsContractListEnabled",
                  this.isContractListEnabled
                );

                this.contractInfoList = response.activeResourceTask.processVariables.find(
                  x => x.code == "contractNames"
                ).value;
                this.$emit(
                  "setContractInfoList",
                  this.contractInfoList
                );

                this.$emit(
                  "setProcessVariablesList",
                  response.activeResourceTask.processVariables
                );

                this.processContractApproved =
                  response.activeResourceTask.processVariables.find(
                    x => x.code == "processContractApproved"
                  ).value === "true"
                    ? true
                    : null;

                this.birthDate = response.activeResourceTask.processVariables.find(
                  x => x.code == "birthDate"
                ).value;

                const enabledButtons = response.activeResourceTask.processVariables.filter(
                  processVariable => {
                    const regex = new RegExp(".*.enabled-web", "g");
                    if (processVariable.code == "processCode") {
                      this.setProcessCode(processVariable.value);
                    }
                    this.setProcessId(response.activeResourceTask.processId);
                    return (
                      regex.test(processVariable.code) &&
                      processVariable.value === "true"
                    );
                  }
                );

                resolve(
                  enabledButtons.map(enabledButton =>
                    enabledButton.code.replace(".enabled-web", "")
                  )
                );
              },
              error => {
                console.log(error);
                ("");
                resolve();
              }
            );
          },
          error => {
            console.log(error, "completeTask-error");
          }
        );
      });
    },
    setProcessId(processId) {
      if (processId != null) {
        this.$store.dispatch("setProcessId", processId);
      } else {
        this.$store.dispatch("clearProcessId");
      }
    },
    getJitsiDomainConfigurations() {
      return new Promise(resolve => {
        PreferenceApi.getJitsiDomainConfigurations(
          this,
          response => {
            if (response && response.result) {
              resolve(response.result);
            } else {
              console.log("response.result preference JITSI_CONF not found.");
              resolve();
            }
          },
          error => {
            console.log(error);
            resolve(null);
          }
        );
      });
    },

    async getJitsiProtocolFromPreferences() {
      const jitsiConfigurations = await this.getJitsiDomainConfigurations();
      const protocolConf = jitsiConfigurations
        ? jitsiConfigurations.find(x => x.code == "JITSI_PROTOCOL")
        : null;

      return protocolConf && protocolConf.value ? protocolConf.value : "https";
    },

    getJitsiDomainFromTask() {
      return new Promise(resolve => {
        const getMyActiveTaskRequest = new GetMyActiveTaskRequest();
        getMyActiveTaskRequest.processId = this.processId;

        TaskApi.getMyActiveTask(
          this,
          getMyActiveTaskRequest,
          response => {
            const vars =
              response &&
              response.activeResourceTask &&
              response.activeResourceTask.processVariables
                ? response.activeResourceTask.processVariables
                : [];

            const jitsiDomain = vars.find(v => v.code === "jitsiDomain");

            if (jitsiDomain && jitsiDomain.value) {
              resolve(jitsiDomain.value);
            } else {
              console.log("jitsiDomain not found in processVariables.");
              resolve(null);
            }
          },
          error => {
            console.log(error);
            resolve(null);
          }
        );
      });
    },

    checkPhoneVerify(interval) {
      LeadPartyApi.get(
        this,
        this.leadPartyId,
        response => {
          if (response.leadPartyDTO.videoPhoneVerified) {
            this.stateValues.phoneApproved = true;
            clearInterval(interval);
          }
        },
        error => {
          // reject(error);
        }
      );
    },
    isEmpty(val){
      return (val === undefined || val == null || val.length <= 0) ? true : false;
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/mixin/JitsiMeeting.js